var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _vm._m(1),
    _vm._v(" "),
    _c("div", { staticClass: "pay-invoice__nav-row h-center-align" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-primary",
          on: {
            click: function($event) {
              $event.preventDefault()
              return _vm.nextStep($event)
            }
          }
        },
        [_vm._v("Pay Another Invoice")]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "css-grid pay-invoice-form__row pay-invoice-form__row--header pay-invoice-form__row--error"
      },
      [
        _c("div"),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "pay-invoice-view__cell pay-invoice-view__cell--header"
          },
          [_vm._v("Payment Error")]
        ),
        _vm._v(" "),
        _c("div")
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "panel" }, [
      _c("div", { staticClass: "css-grid pay-invoice-form__row" }, [
        _c("div"),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "pay-invoice__message pay-invoice__message--error" },
          [
            _vm._v(
              "\n        We are unable to confirm with the payment processor whether or not your payment went through. \n        It's possible the payment might need to be submitted again, but out of an abundance of caution to avoid potential double payment, please contact our office at (360) 210-5658 or accounting@fuelmedical.com \n        and ask them to investigate.\n\n        "
            ),
            _c("br"),
            _c("br"),
            _vm._v(
              "\n        Apologies for any inconvenience this has caused.\n      "
            )
          ]
        ),
        _vm._v(" "),
        _c("div")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }